
  var server = {
    address: 'http://localhost:8088/server'
  }
  export {server}




// WEBPACK FOOTER //
// ./src/components/mfs.server.config.js